var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShrRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 50,
    viewBox: "0 0 93 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M54.9449 0.00256741H68.9736C74.6987 0.00256741 80.1025 -0.236495 85.0975 3.14636C90.0179 6.44954 93 12.1768 93 18.143C93 24.027 90.5809 29.672 85.9047 33.3787C80.9868 37.3297 74.0509 37.0058 68.1664 37.0058H65.989V50H54.9449V0.00256741ZM76.5522 25.6388C79.776 24.59 81.9534 21.7675 81.9534 18.305C81.9534 14.6805 79.5369 12.0971 76.2309 11.2102C73.8144 10.565 70.4261 10.727 68.007 10.727H65.9915V26.2891H68.007C70.7449 26.2891 73.8915 26.4485 76.5522 25.6388Z",
    fill: "#FF2400"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.00393677H11.0466V39.2795H22.0417V0.00393677H33.0883V39.2795H44.0886V0.00393677H55.1326V50.0014H0V0.00393677Z",
    fill: "#FF2400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrRed);
export default __webpack_public_path__ + "static/media/shr-red.be665d66b289fddb1a44d12bece45a5d.svg";
export { ForwardRef as ReactComponent };